import Salesman from '@/page/retail/Salesman';
import Sales from '@/page/retail/query/Sales';
import Cashier from '@/page/retail/query/Cashier';
import Note from '@/page/retail/query/demand/Note';
import BSituation from '@/page/retail/query/business/Situation';
import Report from '@/page/retail/query/flow/Report';
import Reconciliation from '@/page/retail/query/cashier/Reconciliation';
import Analysis from '@/page/retail/query/profit/Analysis';
import CSituation from '@/page/retail/query/customer/Situation';
import Summary from '@/page/retail/query/sales/Summary';
import Setting from '@/page/retail/Setting';
import scheme from '@/page/guide/commission/scheme'
import schemeadd from '@/page/guide/commission/schemeAdd'
import TimeAnalysis from '@/page/retail/query/customer/TimeAnalysis';
export const retail = [
  {
    path: '/retail/setting',
    name: 'setting',
    component: Setting,
    meta: {
      requireAuth: true,
      title: '零售业务设置'
    }
  },
  {
    path: '/retail/query/business/situation',
    name: 'bSituation',
    component: BSituation,
    meta: {
      requireAuth: true,
      title: '营业概况'
    }
  },
  {
    path: '/retail/query/flow/report',
    name: 'report',
    component: Report,
    meta: {
      requireAuth: true,
      title: '流水报表'
    }
  },
  {
    path: '/retail/query/cashier/reconciliation',
    name: 'reconciliation',
    component: Reconciliation,
    meta: {
      requireAuth: true,
      title: '收银对账'
    }
  },
  {
    path: '/retail/query/profit/analysis',
    name: 'analysis',
    component: Analysis,
    meta: {
      requireAuth: true,
      title: '毛利分析'
    }
  },
  {
    path: '/retail/query/customer/situation',
    name: 'cSituation',
    component: CSituation,
    meta: {
      requireAuth: true,
      title: '客单分析'
    }
  },
  {
    path: '/retail/query/sales/summary',
    name: 'salesSummary',
    component: Summary,
    meta: {
      requireAuth: true,
      title: '销售汇总'
    }
  },
  {
    path: '/retail/salesman',
    name: 'salesman',
    component: Salesman,
    meta: {
      requireAuth: true,
      title: '导购员'
    }
  },
  {
    path: '/retail/query/sales',
    name: 'sales',
    component: Sales,
    meta: {
      requireAuth: true,
      title: '导购员提成'
    }
  },
  {
    path: '/retail/query/cashier',
    name: 'cashier',
    component: Cashier,
    meta: {
      requireAuth: true,
      title: '收银员交接班'
    }
  },
  {
    path: '/retail/query/demand/note',
    name: 'note',
    component: Note,
    meta: {
      requireAuth: true,
      title: '缴费单'
    }
  },
  {
    path: '/guide/commission/scheme',
    name: 'scheme',
    component: scheme,
    meta: {
      requireAuth: true,
      title: '提成方案'
    }
  },
  {
    path: '/guide/commission/scheme/add',
    name: '新增提成方案',
    component: schemeadd,
    meta: {
      requireAuth: true,
      title: '新增提成方案'
    }
  },
  {
    path: '/retail/query/customer/time',
    name: 'TimeAnalysis',
    component: TimeAnalysis,
    meta: {
      requireAuth: true,
      title: '客单时段分析'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/retail.route.js